interface mytooltipscope extends ng.IScope {
    tipClass: any;
    text: any;
}

interface myattributes extends ng.IAttributes {
  mytooltip: any;
  tooltipPosition: any;
}

class mytooltip implements ng.IDirective {
    restrict = 'A';
    scope = true;

    public link: (scope: mytooltipscope, element: ng.IAugmentedJQuery, attrs: myattributes, $compile: ng.ICompileService, $document: ng.IDocumentService) => void;

    public mouseoverTooltip(vm, tip, tipActiveClassName,e, element: ng.IAugmentedJQuery) {
      var removetimeout = null;

      tip.addClass(tipActiveClassName);

      var pos = e.target.getBoundingClientRect(),
          offset = $(tip).offset(),
          tipHeight = $(tip).outerHeight(),
          tipWidth = $(tip).outerWidth(),
          elWidth = pos.width || pos.right - pos.left,
          elHeight = pos.height || pos.bottom - pos.top,
          tipOffset = 10;

      if(tip.hasClass('tooltip-right')) {
        offset.top = pos.top - (tipHeight / 2) + (elHeight / 2) + $(window).scrollTop();
        offset.left = pos.right + tipOffset;
      }
      else if(tip.hasClass('tooltip-left')) {
        offset.top = pos.top - (tipHeight / 2) + (elHeight / 2) + $(window).scrollTop();
        offset.left = pos.left - tipWidth - tipOffset;
      }
      else if(tip.hasClass('tooltip-down')) {
        offset.top = pos.top + elHeight + tipOffset + $(window).scrollTop();
        offset.left = pos.left - (tipWidth / 2) + (elWidth / 2);
      }
      else {
        offset.top = pos.top - tipHeight - tipOffset + $(window).scrollTop();
        offset.left = pos.left - (tipWidth / 2) + (elWidth / 2);
      }

      $(tip).offset(offset);

      clearTimeout(removetimeout);
      removetimeout = setTimeout(vm.expireTooltip, 8000, tip,tipActiveClassName);

      element.bind('mouseout', function () {
        clearTimeout(removetimeout);
      });

      tip.bind('mouseout', function () {
        clearTimeout(removetimeout);
      });

    }

    public expireTooltip(tip, tipActiveClassName) {
      tip.removeClass(tipActiveClassName);
    }

    constructor(private $compile: ng.ICompileService) {
      let vm = this;
      var timeout = null;
      var removetimeout = null;
        mytooltip.prototype.link = (scope: mytooltipscope, element: ng.IAugmentedJQuery, attrs: myattributes, $compile: ng.ICompileService, $document: ng.IDocumentService) => {
          var tip = vm.$compile('<div ng-class="tipClass" data-html="true" style="white-space: pre-wrap;">{{ text }}<div class="tooltip-arrow"></div></div>')(scope),
              tipClassName = 'tooltip',
              tipActiveClassName = 'tooltip-show';

          scope.tipClass = [tipClassName];
          scope.text = attrs.mytooltip;

          if(attrs.tooltipPosition) {
            scope.tipClass.push('tooltip-' + attrs.tooltipPosition);
          }
          else {
           scope.tipClass.push('tooltip-down');
          }
          $($document).find('body').append(tip);

          element.bind('mouseover', function (e) {
            clearTimeout(timeout);
            timeout = setTimeout(vm.mouseoverTooltip, 1500, vm, tip,tipActiveClassName,e, element);
          });

          element.bind('mouseout', function (e) {
            clearTimeout(timeout);
          });

          element.bind('click', function (e) {
            tip.addClass(tipActiveClassName);

            var pos = e.target.getBoundingClientRect(),
                offset = $(tip).offset(),
                tipHeight = $(tip).outerHeight(),
                tipWidth = $(tip).outerWidth(),
                elWidth = pos.width || pos.right - pos.left,
                elHeight = pos.height || pos.bottom - pos.top,
                tipOffset = 10;

            if(tip.hasClass('tooltip-right')) {
              offset.top = pos.top - (tipHeight / 2) + (elHeight / 2) + $(window).scrollTop();
              offset.left = pos.right + tipOffset;
            }
            else if(tip.hasClass('tooltip-left')) {
              offset.top = pos.top - (tipHeight / 2) + (elHeight / 2) + $(window).scrollTop();
              offset.left = pos.left - tipWidth - tipOffset;
            }
            else if(tip.hasClass('tooltip-down')) {
              offset.top = pos.top + elHeight + tipOffset + $(window).scrollTop();
              offset.left = pos.left - (tipWidth / 2) + (elWidth / 2);
            }
            else {
              offset.top = pos.top - tipHeight - tipOffset + $(window).scrollTop();
              offset.left = pos.left - (tipWidth / 2) + (elWidth / 2);
            }

            $(tip).offset(offset);

            clearTimeout(removetimeout);
            removetimeout = setTimeout(vm.expireTooltip, 8000, tip,tipActiveClassName);
          });

          element.bind('mouseout', function () {
            tip.removeClass(tipActiveClassName);
            clearTimeout(timeout);
            clearTimeout(removetimeout);
          });

          tip.bind('mouseover', function () {
            tip.addClass(tipActiveClassName);
          });

          tip.bind('mouseout', function () {
            tip.removeClass(tipActiveClassName);
            clearTimeout(timeout);
            clearTimeout(removetimeout);
          });
        }
    };

    public static Factory() {
        var directive = ($compile) => {
            return new mytooltip($compile);
        }
        return directive;
    }
}

export default mytooltip;



// WEBPACK FOOTER //
// ./src/app/tooltip/directive.tooltip.ts